import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "association" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "table-inner mt-5" }
const _hoisted_4 = { class: "table-container js-table-arrow" }
const _hoisted_5 = { class: "stockTable" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "table-container mt-5 js-table-arrow" }
const _hoisted_8 = { class: "stockTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")!
  const _component_EChartsHorizontalBar = _resolveComponent("EChartsHorizontalBar")!
  const _component_EChartsVerticalBar = _resolveComponent("EChartsVerticalBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SectionTitle, { text: "Количество принятых актов Союза (в единицах)" }),
    _createVNode(_component_EChartsHorizontalBar, {
      showLegend: false,
      valueFractionDigits: 0,
      barMaxWidth: 20,
      categoryLabelWidth: 280,
      labels: _ctx.associationActsChartLabels,
      dataset: _ctx.associationActsChartDataset
    }, null, 8, ["labels", "dataset"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SectionTitle, { text: "Количество принятых актов Союза по годам (в единицах)" }),
      _createVNode(_component_EChartsVerticalBar, {
        labels: _ctx.chartYearLabels,
        dataset: _ctx.unionActsChartDataset,
        height: 400,
        legendSelectable: false
      }, null, 8, ["labels", "dataset"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SectionTitle, { text: "Таблица с количеством принятых актов Союза (в единицах)" }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { width: "12%" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" }),
            _createElementVNode("col", { width: "auto" })
          ], -1)),
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("th", null, "Акт"),
            _createElementVNode("th", null, "2012"),
            _createElementVNode("th", null, "2013"),
            _createElementVNode("th", null, "2014"),
            _createElementVNode("th", null, "2015"),
            _createElementVNode("th", null, "2016"),
            _createElementVNode("th", null, "2017"),
            _createElementVNode("th", null, "2018"),
            _createElementVNode("th", null, "2019"),
            _createElementVNode("th", null, "2020"),
            _createElementVNode("th", null, "2021"),
            _createElementVNode("th", null, "2022")
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (tr) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: tr.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr.data, (td, index) => {
                  return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(td), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_SectionTitle, { text: "Количество решений Суда Союза (в единицах)" }),
      _createVNode(_component_EChartsVerticalBar, {
        labels: _ctx.chartYearLabels,
        dataset: _ctx.courtDecisionsChartDataset,
        height: 400,
        legendSelectable: false
      }, null, 8, ["labels", "dataset"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_SectionTitle, { text: "Таблица с количеством решений Суда Союза по годам" }),
      _createElementVNode("table", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("th", { style: {"text-align":"center"} }, "2012"),
          _createElementVNode("th", null, "2013"),
          _createElementVNode("th", null, "2014"),
          _createElementVNode("th", null, "2015"),
          _createElementVNode("th", null, "2016"),
          _createElementVNode("th", null, "2017"),
          _createElementVNode("th", null, "2018"),
          _createElementVNode("th", null, "2019"),
          _createElementVNode("th", null, "2020"),
          _createElementVNode("th", null, "2021"),
          _createElementVNode("th", null, "2022")
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataTwo, (tr) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: tr.id
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr.data, (td, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  style: {"text-align":"center","padding":"34px 27px"},
                  key: index
                }, _toDisplayString(td), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}